const radConfig = {
  allottement_status: false,
  currentUrl: "https://pacsuat.medallcorp.in/",
  previousVisitUrl: "https://medapps.medallcorp.in",
  baseUrl: "https://pacsuat.medallcorp.in/api/quickrad",
  baseUrlRadio: "https://pacsuat.medallcorp.in/api/quickrad/radio",
  radTitle: "AIkenist Technology Pvt. Ltd.",
  viewerURL: "https://pacsuat.medallcorp.in/aikenviewer/viewer/",
  abdmBaseUrl: "https://abdm.aikenist.com",
  viewer3DURL:"https://pacsuat.medallcorp.in/3daikenviewer/viewer?StudyInstanceUIDs=",
  viewerPET:"https://pacsuat.medallcorp.in/3daikenviewer/tmtv?StudyInstanceUIDs=",
  viewerSM:"https://pacsuat.medallcorp.in/3daikenviewer/microscopy?StudyInstanceUIDs=",
  viewerSeg:"https://pacsuat.medallcorp.in/3daikenviewer/segmentation?StudyInstanceUIDs=",
  viewerECG: "https://pacsuat.medallcorp.in/3daikenviewer/ecg?StudyInstanceUIDs=",
  viewerMultiple: "https://pacsuat.medallcorp.in/3daikenviewer/viewer?",
  viewerMultiplePet: "https://pacsuat.medallcorp.in/3daikenviewer/tmtv?",
  medDream:"https://pacsuat.medallcorp.in/?study=",
  thumbnailURL: "https://pacsuat.medallcorp.in/dicom-web/instances/",
  gifURL:
  "https://pacsuat.medallcorp.in/api/quickrad/general/convert-to-gif?series_ins=",
  dicomWeb: "https://pacsuat.medallcorp.in/dicom-web",
  weasisDicomWeb: "https://pacsuat.medallcorp.in/dicom-web",
  studyList: "https://pacsuat.medallcorp.in/dicom-web/studies",
  localViewer: "https://pacsuat.medallcorp.in/aikenviewer/local",
  client: "medalltest",
  paymentComplete: true,
  version: "v2.0",
  metabaseSiteUrl: "https://metabase.aikenist.com",
  metabaseDashboardId: 2,
  metabaseBillingDashboardId: 3,
  metabaseEmbedSecret: "dc6f5251fdbedfe7884946ce6637cf337639e5eafb07ffebcb62bf197493185b",
  metabaseUseLockedParams: true,
  ezhealBaseUrl: "https://demo.ezheal.in/backend",
  radiAntPath: "C:\\xampp\\htdocs\\python\\input_scan\\tmp",
  speedTestUrl: "https://speed.cloudflare.com/__down",
};

// ******************************************

localStorage.setItem("client", radConfig.client);

if (
  localStorage.getItem("showTAT") == "" ||
  localStorage.getItem("showTAT") == null
) {
  localStorage.setItem("showTAT", "false");
}
if (
  localStorage.getItem("studyTracker") == "" ||
  localStorage.getItem("studyTracker") == null
) {
  localStorage.setItem("studyTracker", "false");
}

export default radConfig;
